// We use this approach as the client is not sure of what he wants
// for now we embed take as input name, email, telephone

import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import React from "react";

const AutoClaimReportForm = ({
  name,
  setName,
  email,
  setEmail,
  telephone,
  setTelephone,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Form.Group className="u-mb-small">
        <Form.Label>{t("contact_page_form_input-label_name")}:</Form.Label>
        <Form.Control
          label="Nom:"
          type="text"
          placeholder="Jean Martin Djomo"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Form.Group>
      <Form.Group className="u-mb-small">
        <Form.Label>{t("contact_page_form_input-label_email")}:</Form.Label>
        <Form.Control
          label="Email"
          type="email"
          placeholder="jmardjom362yahoo.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Form.Group>
      <Form.Group className="u-mb-small">
        <Form.Label>{t("contact_page_form_input-label_telephone")}:</Form.Label>
        <Form.Control
          label="Numéro de téléphone:"
          type="phone"
          placeholder="+237675010203"
          value={telephone}
          onChange={(e) => setTelephone(e.target.value)}
        />
      </Form.Group>
    </>
  );
};

export default AutoClaimReportForm;
